import {createSlice} from '@reduxjs/toolkit';

export const initialState = {};

// We no longer need to make a separate actions file or to keep track of the action type name (in most cases)
export const propertyDetailCacheSlice = createSlice({
  name: 'propertyDetailCache',
  initialState,
  // Redux Toolkit + Immer allows us to remove a ton of boilerplate code for easy immutable state updates
  reducers: {
    /**
     * @param state
     * @param action
     */
    putCache: (state, action) => {
      Object.assign(state, action.payload);
    },
    resetCache: () => initialState,
  },
});

export const {putCache, resetCache} = propertyDetailCacheSlice.actions;

export default propertyDetailCacheSlice.reducer;
